import { Component, Vue } from 'types-vue'
import * as _ from 'lodash-es'

@Component
export default class Dashboard extends Vue {
  protected modelexample = '7'
}